const CLASSES = {
  default: "brh-collage",
  get main() {
    return `.${CLASSES.default}`;
  },
  selector: {
    get parallaxVertical() {
      return `${CLASSES.main} .js-parallax-vertical`;
    },
    get animatedWords() {
      return `${CLASSES.main} .js-animate-words`;
    },
  },
};

export default CLASSES;
